import { paths } from 'config/paths';
import { Permission, Scope, useAccess } from './useAccess';
import useMarketAndCatalogRoutes from './useMarketAndCatalogRoutes';
import useUser from './useUser';

export const useHomeRedirectPath = (): string => {
  const { isBuyer, isSeller, isAdmin } = useUser();
  const has = useAccess();
  const { showCatalogRoute, showMarketRoute } = useMarketAndCatalogRoutes();

  if (isBuyer) {
    // A buyer without the market has only their orders to look at.
    if (!has(Permission.Market, Scope.Read)) {
      return paths.shipments();
    }
    // Catalog-only buyers have no traditional market, so land them on the catalog.
    if (showCatalogRoute && !showMarketRoute) {
      return paths.catalogMarket();
    }
    return paths.market();
  }

  if (isSeller) {
    return paths.shipments();
  }

  if (isAdmin) {
    if (has(Permission.Sales, Scope.Read)) return paths.sales();
    if (has(Permission.Finance, Scope.Read)) return paths.payments();
    if (has(Permission.Operations, Scope.Read)) return paths.operations();
    if (has(Permission.Market, Scope.Read)) return paths.market();
  }

  return paths.shipments();
};

export default useHomeRedirectPath;
